/**
 * Auth Context for Super Admin
 * ============================
 * سياق المصادقة للمدير العام
 */

import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('watrly_admin_user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem('watrly_admin_token'));
  const [loading, setLoading] = useState(false);

  const isAuthenticated = !!token && !!user;

  // تسجيل الدخول
  const login = useCallback(async (email, password) => {
    try {
      const response = await authService.login(email, password);
      const { access_token, user: userData } = response;
      
      // حفظ البيانات
      localStorage.setItem('watrly_admin_token', access_token);
      localStorage.setItem('watrly_admin_user', JSON.stringify(userData));
      setToken(access_token);
      setUser(userData);
      
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.detail || 'فشل تسجيل الدخول'
      };
    }
  }, []);

  // تسجيل الخروج
  const logout = useCallback(() => {
    localStorage.removeItem('watrly_admin_token');
    localStorage.removeItem('watrly_admin_user');
    setToken(null);
    setUser(null);
  }, []);

  // تحديث بيانات المستخدم
  const updateUser = useCallback((userData) => {
    setUser(prev => ({ ...prev, ...userData }));
  }, []);

  const value = {
    user,
    token,
    loading,
    isAuthenticated,
    login,
    logout,
    updateUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
